export class ApplicationMessage<TSender> {
  constructor(public sender: TSender) { }
}

export class ApplicationAsyncMessage<TSender, TResult> extends ApplicationMessage<TSender> {
  handlerPromise: Promise<TResult> = null;
}
